var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiAssistantLightTheme = function SvgAiAssistantLightTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.1a.4.4 0 0 1 .38.274l.026.077a2.6 2.6 0 0 0 1.644 1.644l.077.026a.4.4 0 0 1 0 .759l-.077.025a2.6 2.6 0 0 0-1.644 1.645l-.026.077a.4.4 0 0 1-.759 0l-.026-.077a2.6 2.6 0 0 0-1.644-1.645l-.077-.025a.4.4 0 0 1 0-.76l.077-.025a2.6 2.6 0 0 0 1.644-1.644l.026-.077a.4.4 0 0 1 .38-.274ZM8.5 4a.5.5 0 0 1 .485.379l.127.507a5.5 5.5 0 0 0 4.002 4.002l.507.127a.5.5 0 0 1 0 .97l-.507.127a5.5 5.5 0 0 0-4.002 4.002l-.127.507a.5.5 0 0 1-.97 0l-.127-.507a5.5 5.5 0 0 0-4.002-4.002l-.507-.127a.5.5 0 0 1 0-.97l.507-.127a5.5 5.5 0 0 0 4.002-4.002l.127-.507A.5.5 0 0 1 8.5 4Z",
    fill: "url(#ai-assistant-light-theme_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-assistant-light-theme_svg__a",
    x1: 3,
    y1: 15,
    x2: 18.261,
    y2: 6.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0021FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#116DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FF2AE"
  })))));
};
export default SvgAiAssistantLightTheme;